import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Pricing } from './components/Pricing';
import { Process } from './components/Process';
import { Faq } from './components/Faq';
import { StartSection } from './components/StartSection';
import { FinePrint } from './components/FinePrint';
export function App() {
  return <div className="w-full bg-brand-white font-sans text-brand-black antialiased" data-id="element-0" data-mp="3f8ndlgc3j77i">
      <Header data-id="element-1" data-mp="2rl6xrd60p4xg" />
      <main data-id="element-2" data-mp="2rikmp3jx47ah">
        <Hero data-id="element-3" data-mp="2mm2mmgzj8x4h" />
        <Pricing data-id="element-4" data-mp="2mmcc83go129n" />
        <Process data-id="element-5" data-mp="2mmvkesgikcah" />
        <Faq data-id="element-6" data-mp="2mndr6j0sy8wn" />
        <StartSection data-id="element-7" data-mp="2mjpw3ffpleft" />
      </main>
      <FinePrint data-id="element-8" data-mp="31b8jhyaweb97" />
    </div>;
}